import React from 'react';
import styled from 'styled-components';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const LegendaReport = ({
  data,
  data1,
  className,
  type,
  dreOrDr = 'DRE'
}) => {
  const tableData = (data && type == 'dn') ? data.porc_acertos_dn : data.porc_acertos_dre;
  const redeOrDn = 'REDE';

  return (
    <div
      className={className}
      style={{ display: 'flex', justifyContent: 'center', paddingTop: '2rem' }}
    >
      <TableContainer className="table-container">
        <Table>
          <TableHead className="tableHeader">
            <TableRow>
              <TableCell className="text-header" align="center">
                Proficiência
              </TableCell>
              {data1?
              <>
              <TableCell className="text-header" align="center">
                {dreOrDr}(%)
              </TableCell>
              <TableCell className="text-header" align="center">
                {redeOrDn}(%)
              </TableCell>
              </>
              :
              <TableCell className="text-header" align="center">
                %
              </TableCell>
              }

              <TableCell className="text-header right-cell" align="center">
                Faixa de Proficência
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.map((item, index) => (
              <TableRow>
                {/* nivel da proeficiencia */}

                <TableCell
                  className="left-cell data-cell"
                  style={{
                    backgroundColor: index % 2 == 0 ? '#D9D9D9' : '#EDEDED'
                  }}
                >
                  {Object.values(item)[0]}
                </TableCell>

                {/* Porcentagem no nível */}
                {data1?<>
                  <TableCell
                  align="center"
                  className="data-cell"
                  style={{
                    backgroundColor: index % 2 == 0 ? '#D9D9D9' : '#EDEDED'
                  }}
                >
                  {Object.values(item)[2]
                    ? (Object.values(item)[2] * 100).toFixed(0)
                    : '0'}
                  %
                </TableCell>
                <TableCell
                  align="center"
                  className="data-cell"
                  style={{
                    backgroundColor: index % 2 == 0 ? '#D9D9D9' : '#EDEDED'
                  }}
                >
                  {Object.values(data1.porc_acertos_dn[index])[2]?(Object.values(data1.porc_acertos_dn[index])[2]*100).toFixed(0):'0'}
                  %
                </TableCell></>:
                <TableCell
                align="center"
                className="data-cell"
                style={{
                  backgroundColor: index % 2 == 0 ? '#D9D9D9' : '#EDEDED'
                }}
              >
                {Object.values(item)[2]
                  ? (Object.values(item)[2] * 100).toFixed(0)
                  : '0'}
                %
              </TableCell>}

                <TableCell
                  align="center"
                  className="data-cell"
                  style={{
                    backgroundColor: index % 2 == 0 ? '#D9D9D9' : '#EDEDED'
                  }}
                >
                  {Object.values(item)[3]}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default styled(LegendaReport)`
  display: flex;
  align-items: center;
  justify-content: center;

  .table-container {
    width: 70%;
    minwidth: 240px;
  }

  .tableHeader {
    color: #fff;
    font-size: 1.5rem;
  }

  .text-header {
    border: 1px solid gray;
    color: white;
    background-color: ${props => props.theme.primary};
  }
`;
